var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1087 14L1087 42",
    stroke: "#F2DCCE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1087.5,
    cy: 9.33333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.99 9.18978C1082.99 5.28349 1086.29 2.11678 1090.36 2.11678C1090.94 2.11678 1091.51 2.1841 1092.06 2.30756C1090.74 1.48044 1089.19 1 1087.52 1C1082.81 1 1079 4.80558 1079 9.5C1079 14.1944 1082.81 18 1087.52 18C1089.81 18 1091.89 17.0929 1093.43 15.6205C1092.49 16.0317 1091.45 16.2628 1090.36 16.2628C1086.29 16.2628 1082.99 13.0961 1082.99 9.18978Z",
    fill: "#CC7D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.4 8.60027L1096.37 6.14615L1094.54 7.71891L1092.3 7.0564L1093.11 9.33667L1091.77 11.3813L1094.1 11.2179L1095.5 13.144L1096.13 10.7627L1098.34 9.90852L1096.4 8.60027Z",
    fill: "#CC7D61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.da64f37b7681c010fe1e8c3d9d225753.svg";
export { ForwardRef as ReactComponent };